<div class="modal-body modal-padding">
  <div [innerHTML]="message | sanitizeHtml" *ngIf="isDesktop"></div>
  <div *ngIf="!isDesktop" [innerHtml]="message | sanitizeHtml">
  </div>
  <div class="button-wrapper">
      <button class="modal-button-style" (click)="colseModal(); ">Ok</button>
  </div>
</div>
